import React, { useState, useEffect } from 'react';
import { 
  TrendingUp, 
  // TrendingDown, 
  // Users, 
  // DollarSign, 
  // ShoppingCart,
  Eye,
  BarChart3,
  // Calendar,
  // Filter,
  Globe,
  Monitor,
  // Smartphone,
  Laptop,
  AlertCircle,
  // RefreshCw,
  // CalendarDays
} from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../Context/AuthContext';
import { toast } from 'sonner';
// import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { useNavigate } from 'react-router-dom';

// Lightweight UI helpers (no external deps)
// const ToolbarActions = ({ children }) => (
//   <div className="flex items-center space-x-3 mt-4 sm:mt-0">{children}</div>
// );

// const Popover = ({ open, onOpenChange, children }) => {
//   const containerRef = useRef(null);

//   useEffect(() => {
//     if (!open) return;
//     const handleClickAway = (e) => {
//       if (containerRef.current && !containerRef.current.contains(e.target)) {
//         onOpenChange(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickAway);
//     return () => document.removeEventListener('mousedown', handleClickAway);
//   }, [open, onOpenChange]);

//   return (
//     <div ref={containerRef} className="relative">{React.Children.map(children, child => {
//       if (!React.isValidElement(child)) return child;
//       return React.cloneElement(child, { open, onOpenChange });
//     })}</div>
//   );
// };

// const PopoverTrigger = ({ asChild, children, open, onOpenChange }) => (
//   <div onClick={() => onOpenChange(!open)} className="cursor-pointer select-none">
//     {children}
//   </div>
// );

// const PopoverContent = ({ children, open }) => (
//   open ? (
//     <div className="absolute right-0 z-50 mt-2 w-auto rounded-lg border border-gray-700 bg-gray-800 p-0 shadow-xl">
//       {children}
//     </div>
//   ) : null
// );

// const Button = ({ id, variant = 'solid', className = '', onClick, children }) => (
//   <button
//     id={id}
//     onClick={onClick}
//     className={
//       `inline-flex items-center gap-2 h-10 px-4 rounded-xl transition-colors ` +
//       `${variant === 'outline'
//         ? 'border border-gray-500/70 bg-gray-800/40 text-gray-200 hover:bg-gray-700/60 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500/40'
//         : 'bg-purple-600 text-white hover:bg-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/40'} ` +
//       className
//     }
//   >
//     {children}
//   </button>
// );

const Analytics = () => {
  const [analyticsData, setAnalyticsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const [loadingStartTime, setLoadingStartTime] = useState(Date.now());
  const { getToken } = useAuth();
const navigate = useNavigate();
  // Date range states
  // const [isOpen, setIsOpen] = useState(false);
  // const [date, setDate] = useState({ from: undefined, to: undefined });
  // const [tempDateRange, setTempDateRange] = useState({ from: undefined, to: undefined });

  useEffect(() => {
      const fetchAnalyticData = async () => {
        try {
          setLoading(true);
          // setLoadingStartTime(Date.now());
          setError(null);

          const token = getToken();
          if (!token) {
            // setError('No authentication token found');
            setLoading(false);
            return;
          }

          const response = await axios.get('https://apisellhub.com/api/super-admin/analytics', {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          if (response.data.status) {
            setAnalyticsData(response.data);
            // const elapsedTime = Date.now() - loadingStartTime;
            // const minLoadingTime = 800;
            // if (elapsedTime < minLoadingTime) {
            //   setTimeout(() => setLoading(false), minLoadingTime - elapsedTime);
            // } else {
            //   setLoading(false);
            // }
          } else {
            setError('Failed to load analytics data');
            setLoading(false);
          }
        } catch (err) {
          console.error('Analytics API error:', err);
          if (err.response?.status === 401) {
            navigate("/center/login", { replace: true });
            sessionStorage.removeItem("Market-token");
            // setError('Authentication failed. Please login again.');
            toast.error('Token Expired. Please login again.');
          } else {
            setError('Failed to load analytics data');
            toast.error('Failed to load analytics data');
          }
          setLoading(false);
        } finally {
          setLoading(false);
        }
    };

    fetchAnalyticData();
  }, [getToken,navigate]);

  const fetchAnalyticsData = async () => {
    try {
      setLoading(true);
      // setLoadingStartTime(Date.now());
      setError(null);

      const token = getToken();
      if (!token) {
        // setError('No authentication token found');
        setLoading(false);
        return;
      }

      const response = await axios.get('https://apisellhub.com/api/super-admin/analytics', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.data.status) {
        setAnalyticsData(response.data);
        // const elapsedTime = Date.now() - loadingStartTime;
        // const minLoadingTime = 800;
        // if (elapsedTime < minLoadingTime) {
        //   setTimeout(() => setLoading(false), minLoadingTime - elapsedTime);
        // } else {
        //   setLoading(false);
        // }
      } else {
        setError('Failed to load analytics data');
        setLoading(false);
      }
    } catch (err) {
      console.error('Analytics API error:', err);
      if (err.response?.status === 401) {
        navigate("/center/login", { replace: true });
        sessionStorage.removeItem("Market-token");
        // setError('Authentication failed. Please login again.');
        toast.error('Token Expired. Please login again.');
      } else {
        setError('Failed to load analytics data');
        toast.error('Failed to load analytics data');
      }
      setLoading(false);
    } finally{
      setLoading(false);
    }
  };

  // const formatYMD = (d) => (d ? new Date(d).toLocaleDateString('en-CA') : '');
  // const handleDateRangeReset = () => {
  //   setTempDateRange({ from: undefined, to: undefined });
  // };
  // const handleDateRangeApply = () => {
  //   // setDate(tempDateRange);
  //   // setIsOpen(false);
  //   // TODO: If backend supports date filtering, trigger refetch with params here using date.from / date.to
  // };

  // Loading state
  if (loading) {
    return (
      <div className="space-y-6">
        {/* Header Skeleton */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div>
            <div className="h-8 bg-gray-600 rounded w-48 mb-2 animate-pulse"></div>
            <div className="h-4 bg-gray-600 rounded w-64 animate-pulse"></div>
          </div>
          <div className="flex items-center space-x-3 mt-4 sm:mt-0">
            <div className="h-10 bg-gray-600 rounded w-32 animate-pulse"></div>
            <div className="h-10 bg-gray-600 rounded w-20 animate-pulse"></div>
          </div>
        </div>

        {/* Overview Metrics Skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-gray-800 rounded-lg border border-gray-700 p-6">
              <div className="h-4 bg-gray-600 rounded w-24 mb-2 animate-pulse"></div>
              <div className="h-10 bg-gray-600 rounded w-20 mb-4 animate-pulse"></div>
              <div className="h-6 bg-gray-600 rounded w-16 animate-pulse"></div>
            </div>
          ))}
        </div>

        {/* Middle Row Skeleton */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {[1, 2].map((i) => (
            <div key={i} className="bg-gray-800 rounded-lg border border-gray-700 p-6">
              <div className="h-6 bg-gray-600 rounded w-32 mb-4 animate-pulse"></div>
              <div className="space-y-3">
                {[1, 2, 3, 4, 5].map((j) => (
                  <div key={j} className="flex items-center justify-between">
                    <div className="h-4 bg-gray-600 rounded w-20 animate-pulse"></div>
                    <div className="h-4 bg-gray-600 rounded w-16 animate-pulse"></div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Row Skeleton */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {[1, 2].map((i) => (
            <div key={i} className="bg-gray-800 rounded-lg border border-gray-700 p-6">
              <div className="h-6 bg-gray-600 rounded w-32 mb-4 animate-pulse"></div>
              <div className="space-y-3">
                {[1, 2, 3, 4, 5].map((j) => (
                  <div key={j} className="flex items-center justify-between">
                    <div className="h-4 bg-gray-600 rounded w-20 animate-pulse"></div>
                    <div className="h-4 bg-gray-600 rounded w-16 animate-pulse"></div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Loading indicator */}
        <div className="text-center py-8">
          <div className="inline-flex items-center space-x-2 text-gray-400">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-purple-500"></div>
            <span>Loading analytics data...</span>
          </div>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="bg-red-500/20 border border-red-500/50 rounded-lg p-6 text-center">
        <AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
        <h3 className="text-xl font-semibold text-red-400 mb-2">Error Loading Analytics</h3>
        <p className="text-red-300">{error}</p>
        <button 
          onClick={fetchAnalyticsData}
          className="mt-4 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition-colors"
        >
          Try Again
        </button>
      </div>
    );
  }

  // Overview metrics data from API
  const overviewMetrics = [
    {
      name: 'TOTAL VISITORS',
      value: `${analyticsData?.visitorCount?.toLocaleString() || 0}`,
      trend: 'up',
      chartType: 'line',
      color: 'text-purple-400'
    },
    {
      name: 'TOTAL SELLERS',
      value: `${analyticsData?.seller?.toLocaleString() || 0}`,
      trend: 'up',
      chartType: 'line',
      color: 'text-purple-400'
    },
    {
      name: 'CONVERSION RATE',
      value: `${((analyticsData?.conversionRate || 0) * 100).toFixed(2)}%`,
      trend: 'up',
      chartType: 'bar',
      color: 'text-purple-400'
    }
  ];

  // Top countries data from API
  const topCountries = analyticsData?.countries || [];

  // Top devices data from API
  const topDevices = analyticsData?.devices || [];

  // Top browsers data from API
  const topBrowsers = analyticsData?.browsers || [];

  // Top platforms data from API
  const topPlatforms = analyticsData?.platforms || [];

  // Mini chart components
  const MiniLineChart = ({ data, color = 'text-purple-400' }) => (
    <div className="flex items-center space-x-1">
      {[...Array(6)].map((_, i) => (
        <div
          key={i}
          className={`w-1 h-${Math.floor(Math.random() * 4) + 2} ${color} rounded-full`}
        />
      ))}
    </div>
  );

  const MiniBarChart = ({ data, color = 'text-purple-400' }) => (
    <div className="flex items-end space-x-1 h-6">
      {[...Array(5)].map((_, i) => (
        <div
          key={i}
          className={`w-1 ${color} rounded-t-sm`}
          style={{ height: `${Math.floor(Math.random() * 100) + 20}%` }}
        />
      ))}
    </div>
  );

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-2xl font-bold text-white">Analytics Dashboard</h2>
          <p className="text-gray-400">Visitor and seller analytics overview</p>
        </div>
     
      </div>

      {/* Overview Metrics - Top Row */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {overviewMetrics.map((metric) => (
          <div key={metric.name} className="relative overflow-hidden bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl border border-gray-700 p-6 transition-all duration-300 group hover:-translate-y-0.5 hover:border-yellow-500/40 hover:shadow-[0_10px_30px_-10px_rgba(234,179,8,0.25)]">
            <div className="pointer-events-none absolute -top-10 -right-10 h-36 w-36 rounded-full bg-yellow-500/10 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <div className="flex items-center justify-between relative z-10">
              <div>
                <p className="text-sm font-medium text-gray-400 mb-2">{metric.name}</p>
                <p className="text-3xl font-bold text-white transition-colors duration-300 group-hover:text-yellow-300">{metric.value}</p>
                <span className="mt-2 block h-px w-10 bg-gradient-to-r from-yellow-500/70 to-transparent group-hover:w-16 transition-all duration-300" />
              </div>
              <div className="flex items-center space-x-2">
                {metric.chartType === 'line' ? (
                  <MiniLineChart color={metric.color} />
                ) : (
                  <MiniBarChart color={metric.color} />
                )}
                {metric.trend === 'up' && (
                  <TrendingUp className="h-4 w-4 text-green-400" />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Middle Row - Countries and Devices */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Top Countries */}
        <div className="relative overflow-hidden bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl border border-gray-700 p-6 transition-all duration-300 hover:-translate-y-0.5 hover:border-yellow-500/40 hover:shadow-[0_10px_30px_-10px_rgba(234,179,8,0.25)]">
          <div className="pointer-events-none absolute -top-10 -right-10 h-36 w-36 rounded-full bg-yellow-500/10 blur-2xl" />
          <div className="flex items-center space-x-2 mb-4">
            <Globe className="h-5 w-5 text-yellow-400" />
            <h3 className="text-lg font-semibold text-white">TOP COUNTRIES</h3>
          </div>
          <div className="space-y-1">
            {topCountries.map((country, index) => (
              <div key={index} className="flex items-center justify-between rounded-lg px-2 py-2 transition-colors duration-200 hover:bg-gray-700/50">
                <div className="flex items-center space-x-3">
                  <span className="text-sm text-gray-400 w-6">{index + 1}</span>
                  <span className="text-sm text-white">{country.country}</span>
                </div>
                <span className="text-sm font-medium text-gray-300">{country.total.toLocaleString()}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Top Devices */}
        <div className="relative overflow-hidden bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl border border-gray-700 p-6 transition-all duration-300 hover:-translate-y-0.5 hover:border-yellow-500/40 hover:shadow-[0_10px_30px_-10px_rgba(234,179,8,0.25)]">
          <div className="pointer-events-none absolute -top-10 -right-10 h-36 w-36 rounded-full bg-yellow-500/10 blur-2xl" />
          <div className="flex items-center space-x-2 mb-4">
            <Monitor className="h-5 w-5 text-yellow-400" />
            <h3 className="text-lg font-semibold text-white">TOP DEVICE</h3>
          </div>
          <div className="space-y-1">
            {topDevices.map((device, index) => (
              <div key={index} className="flex items-center justify-between rounded-lg px-2 py-2 transition-colors duration-200 hover:bg-gray-700/50">
                <div className="flex items-center space-x-3">
                  <span className="text-sm text-gray-400 w-6">{index + 1}</span>
                  <span className="text-sm text-white">{device.device}</span>
                </div>
                <span className="text-sm font-medium text-gray-300">{device.total.toLocaleString()}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Row - Browsers and Platforms */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Top Browsers */}
        <div className="relative overflow-hidden bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl border border-gray-700 p-6 transition-all duration-300 hover:-translate-y-0.5 hover:border-yellow-500/40 hover:shadow-[0_10px_30px_-10px_rgba(234,179,8,0.25)]">
          <div className="pointer-events-none absolute -top-10 -right-10 h-36 w-36 rounded-full bg-yellow-500/10 blur-2xl" />
          <div className="flex items-center space-x-2 mb-4">
            <BarChart3 className="h-5 w-5 text-yellow-400" />
            <h3 className="text-lg font-semibold text-white">TOP BROWSERS</h3>
          </div>
          <div className="space-y-1">
            {topBrowsers.map((browser, index) => (
              <div key={index} className="flex items-center justify-between rounded-lg px-2 py-2 transition-colors duration-200 hover:bg-gray-700/50">
                <div className="flex items-center space-x-3">
                  <span className="text-sm text-gray-400 w-6">{index + 1}</span>
                  <span className="text-sm text-white">{browser.browser}</span>
                </div>
                <span className="text-sm font-medium text-gray-300">{browser.total.toLocaleString()}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Top Platforms */}
        <div className="relative overflow-hidden bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl border border-gray-700 p-6 transition-all duration-300 hover:-translate-y-0.5 hover:border-yellow-500/40 hover:shadow-[0_10px_30px_-10px_rgba(234,179,8,0.25)]">
          <div className="pointer-events-none absolute -top-10 -right-10 h-36 w-36 rounded-full bg-yellow-500/10 blur-2xl" />
          <div className="flex items-center space-x-2 mb-4">
            <Laptop className="h-5 w-5 text-yellow-400" />
            <h3 className="text-lg font-semibold text-white">TOP PLATFORMS</h3>
          </div>
          <div className="space-y-1">
            {topPlatforms.map((platform, index) => (
              <div key={index} className="flex items-center justify-between rounded-lg px-2 py-2 transition-colors duration-200 hover:bg-gray-700/50">
                <div className="flex items-center space-x-3">
                  <span className="text-sm text-gray-400 w-6">{index + 1}</span>
                  <span className="text-sm text-white">{platform.platform}</span>
                </div>
                <span className="text-sm font-medium text-gray-300">{platform.total.toLocaleString()}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Recent Visitors Table */}
      {analyticsData?.visitors && analyticsData.visitors.length > 0 && (
        <div className="bg-gray-800 rounded-lg border border-gray-700 p-6">
          <div className="flex items-center space-x-2 mb-4">
            <Eye className="h-5 w-5 text-yellow-400" />
            <h3 className="text-lg font-semibold text-white">RECENT VISITORS</h3>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-700">
              <thead className="bg-gray-700">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                    IP Address
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                    Device
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                    Platform
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                    Browser
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                    Country
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                    Visited URL
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
                    Time
                  </th>
                </tr>
              </thead>
              <tbody className="bg-gray-800 divide-y divide-gray-700">
                {analyticsData.visitors.slice(0, 10).map((visitor) => (
                  <tr key={visitor.id} className="hover:bg-gray-700">
                    <td className="px-4 py-3 whitespace-nowrap">
                      <div className="text-sm font-medium text-white">{visitor.ip_address}</div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <div className="text-sm text-white">{visitor.device || 'Unknown'}</div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <div className="text-sm text-white">{visitor.platform || 'Unknown'}</div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <div className="text-sm text-white">{visitor.browser || 'Unknown'}</div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <div className="text-sm text-white">{visitor.country}</div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <div className="text-sm text-white max-w-xs truncate" title={visitor.visited_url}>
                        {visitor.visited_url}
                      </div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <div className="text-sm text-white">
                        {new Date(visitor.created_at).toLocaleString()}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

  
    </div>
  );
};

export default Analytics;
